import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    /**
     * Indicates that the user is attempting to view the
     * {@link ents.core.summit.Pulse}
     */
    view: store.actions.standalone({
      data: store.actions.Data.NONE,
    }),
    /**
     * Retrieves the {@link ents.core.summit.Pulse}
     */
    load: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<ents.core.summit.Pulse | undefined>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          pulse: { loading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          pulse: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          pulse: { error },
        }),
      },
    }),
    /**
     * Sets the date for which the {@link ents.core.summit.Pulse} data should be
     * retrieved
     */
    setDate: store.actions.standalone({
      data: store.actions.Data.asIs<{
        fromDate: Date
      }>(),
      reducer: ({ state, data: { fromDate } }) => ({
        ...state,
        fromDate,
      }),
    }),
    /**
     * Indicates that the current {@link ents.core.summit.Pulse} is no longer
     * relevant
     *
     * Mostly useful when the context (e.g. zone) changes
     */
    clear: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({ ...state, pulse: undefined }),
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
